import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DangerError, WarningError } from '@shared/errors/custom.error';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  constructor(private toastr: ToastrService) {}

  handle(error: any, message = "Se produjo un error inesperado"): void {
      if (error instanceof WarningError) this.toastr.warning(error.message);
      else if (error instanceof DangerError) this.toastr.error(error.message);
      else if (error.status === 400) this.toastr.error(error.error.msg);
      else this.toastr.error(message);
  }
}